"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyClassification = void 0;
var PropertyClassification;
(function (PropertyClassification) {
    PropertyClassification[PropertyClassification["Residential"] = 1] = "Residential";
    PropertyClassification[PropertyClassification["Commercial"] = 2] = "Commercial";
    PropertyClassification[PropertyClassification["Industrial"] = 3] = "Industrial";
    PropertyClassification[PropertyClassification["Public"] = 4] = "Public";
    PropertyClassification[PropertyClassification["Multi-Family"] = 5] = "Multi-Family";
})(PropertyClassification = exports.PropertyClassification || (exports.PropertyClassification = {}));
//# sourceMappingURL=PropertyClassification.js.map